// extracted by mini-css-extract-plugin
export default {"procast":"clientpro_procast__WwN4t","user":"clientpro_user__iXyjN","detailDiv":"clientpro_detailDiv__SjzP4","Application":"clientpro_Application__nfIO9"};